import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=9b5e132a"
import script from "./ActionDetail.vue?vue&type=script&lang=js"
export * from "./ActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports